import 'flag-icon-css/css/flag-icon.css';
import './css/App.css';
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import * as RoutesModule from './routes';
import { ErrorBoundary } from './components/ErrorBoundary';
import { I18nextProvider } from 'react-i18next';
import i18n, { i18nReady } from './language/i18n';
import { CountryProvider } from './context/CountryContext';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { theme } from './theme';
import { LicenseInfo } from "@mui/x-license";

// Disable MUI X Telemetry - hardcoded to always be off
// @ts-expect-error - MUI X telemetry global flag
globalThis.__MUI_X_TELEMETRY_DISABLED__ = true;

LicenseInfo.setLicenseKey(
  "7ab1f2c94aba8a5d7ecb5b1dc8d82677Tz0xMjEwMDYsRT0xNzkzMjMxOTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y"
);

const routes = RoutesModule.routes;
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href')!;

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 1,
            staleTime: 30_000
        }
    }
});

function renderApp() {
    createRoot(document.getElementById('react-app')!).render(
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <ErrorBoundary>
                <QueryClientProvider client={queryClient}>
                    <CountryProvider>
                        <I18nextProvider i18n={i18n}>
                            <BrowserRouter basename={baseUrl}>
                                {routes}
                            </BrowserRouter>
                        </I18nextProvider>
                    </CountryProvider>
                </QueryClientProvider>
            </ErrorBoundary>
        </ThemeProvider>
    );
}

// Defer render until i18n is initialized so NavMenu's withTranslation HOC
// never suspends on the first paint (resources are bundled so this resolves immediately)
i18nReady.then(renderApp);
